import { API,   API_POST,  } from "../../Config"


 export const handleAddPageLinks =  (payload) => {
  
    const f= new FormData();

    f.append("name", payload.name)
    f.append("description", payload.description)
    f.append("link", payload.link)
    f.append("photo", payload.file)
   

    return API_POST(API.AddHomepageLinks , f)
}

